import React from "react";
import classNames from "classnames";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";

const Grid = (props) => {
  const gridClass = classNames("osm-u-grid", "osm-u-grid-2", {
    "u-border-b-dotted": props.borderBottom,
    "u-border-t-dotted": props.borderTop,
    "u-space-mb-10 u-space-mt-10": props.verticalMargin,
    "u-space-pt-10 u-space-pb-10": props.verticalPadding,
    "u-space-p-10": props.fullPadding,
    "Content-children-inherit": props.color,
    "osm-u-grid--padding": props.columnSpacing,
    "Content-flex": props.verticalAlign,
    [`osm-u-grid-2--${props.gridType}`]: props.gridType !== "equal",
  });

  const gridStyles = {
    backgroundColor:
      props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
    color: props.color && props.color.length > 0 ? props.color : null,
  };

  return (
    <div className={gridClass} style={gridStyles}>
      {props.children && <ContentEditorComponent content={props.children} />}
    </div>
  );
};

export default Grid;
